import { getId } from '../../helpers/file';
import { getFailedFiles } from '../../helpers/uploadState';

const maskEmail = (email?: string) => {
  if (!email || !email.includes('@')) return email;
  const [name, domain] = email.split('@');
  return `${name.slice(0, 1)}***@${domain}`;
};

const safeJson = async (res: Response) => {
  try {
    return await res.json();
  } catch {
    return null;
  }
};

export const collectSupportContext = async (extra: Record<string, unknown> = {}) => {
  const uid = getId() || undefined;
  const latestFailure = getFailedFiles().slice(-1)[0];

  const context: Record<string, unknown> = {
    source: 'img-cloud',
    uid,
    route: window.location.pathname,
    path: window.location.pathname,
    lastUploadError: latestFailure ? {
      fileName: latestFailure.fileName,
      errorMessage: latestFailure.errorMessage,
      traceId: latestFailure.traceId,
      fileSize: latestFailure.fileSize,
      fileType: latestFailure.fileType,
    } : undefined,
    ...extra,
  };

  try {
    const [loginRes, storageRes] = await Promise.allSettled([
      fetch('/login/info', { credentials: 'include' }).then(safeJson),
      fetch('/img/stat').then(safeJson),
    ]);

    if (loginRes.status === 'fulfilled' && loginRes.value?.isSuccess) {
      const detail = loginRes.value.detail || {};
      context.user = {
        uid,
        loggedIn: true,
        emailMasked: maskEmail(detail.email || detail.username),
        vip: Boolean(detail.vip),
        vipEndTime: detail.vipEndTime,
        path: window.location.pathname,
      };
    } else {
      context.user = { uid, loggedIn: false, path: window.location.pathname };
    }

    if (storageRes.status === 'fulfilled' && storageRes.value) {
      context.storage = {
        totalSize: storageRes.value.totalSize,
        fileCount: storageRes.value.count || storageRes.value.fileCount,
      };
    }
  } catch {
    context.user = { uid, loggedIn: false, path: window.location.pathname };
  }

  return context;
};
